function fn_layout_main() {
    var $body = $("body");
    $body.append('<button id="bg"></button>');

    setTimeout(function(){
        $body.removeClass("preload");
    }, 300);

    $(".select").select2();

    $(".select").on('select2:select', function (e) {
        e.currentTarget.dispatchEvent(new Event('change', { bubbles: true }))
    });

    if ($('#fulltext').length) {
       $('[data-header-search]').addClass("icon-close").parents(".search").addClass("active").find("input").fadeIn(500);
    }

    console.log("fancy");

    $("[data-fancybox-banner]").fancybox({
        closeBtn: true
    }).trigger('click');


    var closeBannerAfter = parseInt($('body').attr('data-close-popup-after'));

    setTimeout(function(){
        if($('.homepage-popup').length) {
            $('.fancybox-item.fancybox-close').trigger('click');
        }
    }, closeBannerAfter * 1000);


    if($('[data-lib-recaptcha]').length) {
        if(typeof grecaptcha !== 'undefined') {
            grecaptcha.ready(function () {
                grecaptcha.execute('6LeQer8UAAAAAFhIJv4iSZjBAh-bgWkFA1qRDgpT', {action: 'form'}).then(function (token) {
                    $('[data-lib-recaptcha]').find('[name="gtoken"]').val(token);
                });
            });
        }
    }

}
